var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-user-avatar",class:{ circle: _vm.circle },style:(_setup.avatarStyle)},[(_setup.pictureUrl)?_c('img',{staticClass:"picture",attrs:{"src":_setup.pictureUrl,"alt":_vm.name}}):_c('span',{staticClass:"initials"},[_vm._v(_vm._s(_setup.initials))]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }